import { useState } from "react";

export default function MasterPlan({ hotspots = [], note }) {
    const [active, setActive] = useState(null);
    const current = hotspots.find((h) => h.label === active);

    return (
        <div className="grid gap-6 lg:grid-cols-12">
            <div className="overflow-hidden rounded-2xl border border-black/10 bg-obsidian/70 lg:col-span-8">
                <svg viewBox="0 0 800 460" className="h-auto w-full" role="img" aria-label="Illustrative master plan">
                    <rect x="20" y="20" width="760" height="420" rx="18" fill="#F1ECE4" stroke="rgba(28,37,52,0.12)" />
                    <path d="M60 400 C 240 340, 420 380, 740 300" stroke="rgba(201,111,74,0.3)" strokeWidth="14" fill="none" strokeLinecap="round" />
                    <ellipse cx="620" cy="360" rx="110" ry="52" fill="rgba(16,185,129,0.10)" stroke="rgba(16,185,129,0.3)" />
                    <ellipse cx="150" cy="120" rx="90" ry="40" fill="rgba(16,185,129,0.07)" stroke="rgba(16,185,129,0.22)" />
                    <rect x="440" y="290" width="90" height="46" rx="20" fill="rgba(37,211,102,0.10)" stroke="rgba(201,111,74,0.4)" />
                    {[["A", 170, 80], ["B", 360, 40], ["C", 550, 100]].map(([t, x, y]) => (
                        <g key={t}>
                            <rect x={x} y={y} width="82" height="150" rx="10" fill="rgba(201,111,74,0.10)" stroke="rgba(201,111,74,0.55)" />
                            <text x={x + 41} y={y + 78} textAnchor="middle" fill="#C96F4A" fontSize="20" fontFamily="'Cormorant Garamond', serif">
                                {t}
                            </text>
                        </g>
                    ))}
                    <rect x="290" y="270" width="84" height="60" rx="8" fill="rgba(28,37,52,0.04)" stroke="rgba(201,111,74,0.4)" />
                    <text x="332" y="304" textAnchor="middle" fill="#57616F" fontSize="10" fontFamily="'JetBrains Mono', monospace">CLUB</text>
                    <path d="M60 440 h680" stroke="rgba(28,37,52,0.1)" strokeDasharray="4 6" />
                    {hotspots.map((h) => (
                        <g key={h.label} className="cursor-pointer" onClick={() => setActive(h.label === active ? null : h.label)}>
                            <circle cx={h.x} cy={h.y} r="16" fill="rgba(201,111,74,0.15)" />
                            <circle
                                cx={h.x}
                                cy={h.y}
                                r="6"
                                fill={active === h.label ? "#B25A38" : "#C96F4A"}
                                stroke="#FAF8F4"
                                strokeWidth="2"
                            />
                        </g>
                    ))}
                </svg>
            </div>
            <div className="lg:col-span-4">
                <div className="flex h-full flex-col rounded-2xl border border-black/10 bg-surface/60 p-6">
                    <p className="eyebrow">Site Markers</p>
                    <div className="mt-4 flex flex-wrap gap-2" data-testid="masterplan-hotspots">
                        {hotspots.map((h) => (
                            <button
                                key={h.label}
                                type="button"
                                data-testid={`masterplan-hotspot-${h.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                                onClick={() => setActive(h.label === active ? null : h.label)}
                                className={`rounded-full border px-3.5 py-1.5 text-xs transition-colors ${
                                    active === h.label
                                        ? "border-gold bg-gold/10 text-gold"
                                        : "border-black/10 text-mist hover:border-gold/40 hover:text-ivory"
                                }`}
                            >
                                {h.label}
                            </button>
                        ))}
                    </div>
                    <div className="mt-6 flex-1 rounded-xl bg-obsidian/60 p-5">
                        {current ? (
                            <>
                                <h4 className="font-serif text-xl text-gold">{current.label}</h4>
                                <p className="mt-2 text-sm leading-relaxed text-mist">{current.desc}</p>
                            </>
                        ) : (
                            <p className="text-sm text-dim">
                                Select a marker to read about that part of the concept site.
                            </p>
                        )}
                    </div>
                    {note && <p className="mt-4 text-[11px] text-dim">{note}</p>}
                </div>
            </div>
        </div>
    );
}
